import axiosInstance from '@/utils/api.js'

var state = {
  iptvServiceLink: []
}

var getters = {
  IPTV_SERVICE_LINK: (state) => {
    return state.iptvServiceLink
  }
}

var mutations = {
  SET_IPTV_SERVICE_LINK: (state, payload) => {
    state.iptvServiceLink = payload || []
  }
}

var actions = {
  GET_IPTV_SERVICE_LINK: async (context, payload) => {
    let result = await axiosInstance.get('/users/servicelinks/iptv?slink_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_IPTV_SERVICE_LINK', result.data)
    }
  },
  CREATE_IPTV_SERVICE_LINK: (context, payload) => {
    return axiosInstance.post('/users/servicelinks/iptv', payload, {timeout: 45000})
  },
  UPDATE_IPTV_SERVICE_LINK: (context, payload) => {
    return axiosInstance.put('/users/servicelinks/iptv', payload, {timeout: 45000})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/servicesLinkIPTV.js